
export const ok = (entity, message = "") => ({entity, message, status: true});
export const ko = (message = "") => ({message, status: false, entity: null});
export const koFromError = (error, message = "") => ko(error?.response?.data ?? message);

